// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1w-js","text":"SelectPayment_text__hkQe8","title":"SelectPayment_title__2J9cR","btn":"SelectPayment_btn__2Os_a"};